import React, { PureComponent } from "react";
import { Col } from "reactstrap";
import { Field, reduxForm } from "redux-form";
import PropTypes from "prop-types";
import renderSelectField from "../../../../../../shared/components/form/Select";
import * as proxies from "../../../../../../shared/service/proxies";
import ReactTags from "react-tag-autocomplete";

class HorizontalForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  state = {
    subnet_suggestions: [],
    subnets: [],
    noOfProxies: 0,
    proxies: [],
    proxiesUpdated: false,
    proxylist_suggestions: [],
    proxylist: [],
    busy: false,
    suggestions: [],
    editSubnetId: 0,
  };

  componentDidMount() {
    let product = this.props.edit;
    if (product.proxies === null || product.proxies === undefined) {
      product.proxies = [];
    }

    this.props.initialize(product);

    let subnets = product.proxies;

    subnets.map(async (subnet) => {
      if (subnet.proxies === undefined) {
        subnet.proxies = [];
      }

      subnet.proxies.map((proxy, index) => {
        if (proxy.slug === undefined) {
          subnet.proxies[index] = {
            slug: proxy,
            name: proxy,
          };
        }

        return proxy;
      });

      return await subnet;
    });
    product.proxies = subnets;

    this.setState(product, () => {
      this.props.handleForm(this.state);
    });
  }

  updateProxies = (proxy) => {
    this.getProxies({ location: proxy.lid, subnet: proxy.sid }).then(
      (proxies) => {
        this.setState({
          editSubnetId: proxy.sid,
          proxies_suggestions: proxies,
        });
      }
    );
  };

  getSuggestions = (proxy) => {
    proxies
      .get({ location: proxy.lid, subnet: proxy.sid })
      .then(async (response) => {
        let proxylist = [];
        await response.forEach((proxy) => {
          proxylist.push({
            slug: proxy.ip,
            name: proxy.ip,
          });
        });

        return proxylist;
      });
  };

  getProxies = (filters) => {
    return proxies.get(filters).then(async (response) => {
      let proxylist = [];
      response.forEach((proxy) => {
        proxylist.push({
          slug: proxy.ip,
          name: proxy.ip,
        });
      });

      return await proxylist;
    });
  };

  cancelCreation = () => {
    this.props.reset();
    this.props.cancelCreation();
  };

  getLocations = () => {
    let locations = [];
    this.props.subnets.forEach((subnet) => {
      let location = locations.filter(
        (obj) => obj.value === subnet.geo_maxmind
      );

      if (location.length === 0) {
        locations.push({
          value: subnet.geo_maxmind,
          label: subnet.geo_maxmind,
        });
      }
    });
    locations.sort(function(a, b) {
      var x = a["value"];
      var y = b["value"];
      return x < y ? -1 : x > y ? 1 : 0;
    });

    return locations;
  };

  filterSubnets = (event) => {
    let filteredSubnets = this.props.subnets.filter(
      (obj) => event.value === obj.geo_maxmind
    );

    let subnets = [];
    filteredSubnets.forEach((subnet) => {
      subnets.push({
        slug: subnet.sid,
        name: subnet.subnet,
      });
    });

    this.setState({ subnet_suggestions: subnets, subnets: [] });
  };

  onDelete(i) {
    const subnets = this.state.subnets.slice(0);
    subnets.splice(i, 1);
    this.setState({ subnets }, () => {
      this.props.handleForm(this.state);
    });
  }

  onAddition(subnet) {
    const subnets = [].concat(this.state.subnets, subnet);
    this.setState({ subnets }, () => {
      this.props.handleForm(this.state);
    });
  }

  onDeleteProxy(selectedProxyIndex, obj) {
    obj.proxies.splice(selectedProxyIndex, 1);
    this.props.handleForm(this.state);
  }

  onAdditionProxy(proxy, obj) {
    if (obj.proxies === undefined) {
      obj.proxies = [];
    }

    obj.proxies.push(proxy);
    this.props.handleForm(this.state);
  }

  removeProxy = (proxy) => {
    this.setState(
      {
        proxies: this.state.proxies.filter((obj) => proxy.sid !== obj.sid),
        proxiesUpdated: true,
      },
      () => {
        this.props.handleForm(this.state);
      }
    );
  };

  addProxies = () => {
    let proxies = this.state.proxies;

    if (this.state.subnets.length > 0 && this.state.noOfProxies > 0) {
      let subnets = this.state.subnets;

      let mod = parseInt(
        parseInt(this.state.noOfProxies) % this.state.subnets.length
      );

      subnets.map((subnet) => {
        let subnetObj = this.props.subnets.filter(
          (obj) => subnet.name === obj.subnet
        );

        if (subnetObj.length > 0) {
          Object.keys(subnetObj[0]).forEach(function(key) {
            subnet[key] = subnetObj[0][key];
          });
        }

        subnet["no"] =
          parseInt(
            parseInt(this.state.noOfProxies) / this.state.subnets.length
          ) + mod;

        mod = 0;

        return subnet;
      });

      subnets.forEach((subnet) => {
        this.getProxies({
          location: subnet.lid,
          sid: subnet.sid,
          no: subnet.no,
        }).then((response) => {
          proxies.push({
            sid: subnet.sid,
            subnet: subnet.subnet,
            lid: subnet.lid,
            no: subnet.no,
            location: subnet.geo_maxmind,
            proxies: this.getRandom(response, subnet.no), //.slice(0, subnet.no),
            proxies_suggestions: response,
          });

          this.setState(
            {
              editSubnetId: subnet.sid,
              proxies_suggestions: response,
              proxies: proxies,
              subnets: [],
              proxiesUpdated: true,
            },
            () => {
              this.props.handleForm(this.state);
            }
          );
        });
      });
    } else {
      console.error(["Please select subnet(s) and number of proxies."]);
    }
  };

  getRandom = (arr, n) => {
    var result = new Array(n),
      len = arr.length,
      taken = new Array(len);
    // if (n > len) {
    //   alert("Sufficent proxies are not available.");
    // }

    while (n--) {
      var x = Math.floor(Math.random() * len);
      result[n] = arr[x in taken ? taken[x] : x];
      taken[x] = --len in taken ? taken[len] : len;
    }
    return result;
  };

  formConnectionHandlerType = (event) => {
    if (event.value !== "custom") {
      this.props.products.forEach((product) => {
        if (event.value === product.id) {
          this.setState(
            {
              api: product.api,
              cost: product.cost,
              id: product.id,
              name: product.name,
              proxies: product.proxies,
              type: product.type,
              valid: product.valid,
              website: product.website,
            },
            () => {
              this.props.initialize(this.state);
              this.props.handleForm(this.state);
            }
          );
        }
      });
    }

    this.setState({ type: event.value }, () => {
      this.props.handleForm(this.state);
    });
  };

  formConnectionHandlerWebsite = (event) => {
    this.setState({ website: event.value }, () => {
      this.props.handleForm(this.state);
    });
  };

  formConnectionHandlerUsage = (event) => {
    this.setState({ usage: event.value }, () => {
      this.props.handleForm(this.state);
    });
  };

  formConnectionHandler = (event) => {
    this.setState({ concurrent_connection: event.value }, () => {
      this.props.handleForm(this.state);
    });
  };

  formLocationHandler = (event) => {
    this.setState({ proxyLocation: event });
  };

  formChangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value;

    this.setState({ [nam]: val }, () => {
      this.props.handleForm(this.state);
    });
  };

  proxiesChangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value;

    this.setState({ [nam]: val }, () => {});
  };

  render() {
    const { handleSubmit } = this.props;

    return (
      <Col md={12} lg={12}>
        <div className="card__title">
          <h5 className="bold-text">
            {this.state.status === "active" ? "Update Proxies" : "Proxies"} -
            {this.state.name}
          </h5>
        </div>
        <form
          autoComplete="off"
          className="form form--horizontal"
          onSubmit={handleSubmit}
        >
          <React.Fragment>
            {this.state.status === "active" ? (
              <React.Fragment>
                <div className="form__form-group">
                  <div className="form__form-group-label col-sm-3 col-md-3">
                    Location
                  </div>
                  <div className="form__form-group-label col-sm-3 col-md-3">
                    Subnets
                  </div>
                  <div className="form__form-group-field col-sm-3 col-md-3">
                    Proxies
                  </div>
                </div>
                <div className="form__form-group">
                  <div className="col-sm-3 col-md-3">
                    <Field
                      name="location"
                      component={renderSelectField}
                      options={this.getLocations()}
                      onChange={this.filterSubnets}
                    />
                  </div>
                  <div className="col-sm-3 col-md-3">
                    <ReactTags
                      ref={this.inputRef}
                      tags={this.state.subnets}
                      allowNew="false"
                      suggestions={this.state.subnet_suggestions}
                      onDelete={this.onDelete.bind(this)}
                      onAddition={this.onAddition.bind(this)}
                      placeholderText="Add location"
                      addOnBlur="true"
                      minQueryLength="1"
                    />
                  </div>
                  <div className="col-sm-3 col-md-3">
                    <Field
                      name="noOfProxies"
                      component="input"
                      type="number"
                      placeholder="No of proxies"
                      min="1"
                      onKeyUp={this.formChangeHandler}
                    />
                  </div>
                  <div className="col-sm-3 col-md-3 successParentDiv">
                    <span
                      className="lnr lnr-plus-circle"
                      title="Add"
                      onClick={this.addProxies}
                    ></span>
                  </div>
                </div>
              </React.Fragment>
            ) : (
              ""
            )}

            {this.state.proxies.map((proxy, proxyIndex) => (
              <div className="form__form-group" key={proxyIndex}>
                <div className="col-sm-3 col-md-3">{proxy.location}</div>
                <div className="col-sm-3 col-md-3">{proxy.subnet}</div>
                <div className="col-sm-3 col-md-3">
                  {this.state.editSubnetId === proxy.sid ? (
                    <ReactTags
                      ref={this.inputRef}
                      tags={proxy.proxies}
                      allowNew="false"
                      suggestions={this.state.proxies_suggestions}
                      onDelete={(selectedProxy) =>
                        this.onDeleteProxy(selectedProxy, proxy)
                      }
                      onAddition={(selectedProxy) => {
                        this.onAdditionProxy(selectedProxy, proxy);
                      }}
                      placeholderText="Add Proxy"
                      addOnBlur="false"
                      minQueryLength="1"
                    />
                  ) : (
                    proxy.proxies.map((proxy) => (
                      <span className="w3-badge" key={proxy.slug}>
                        {proxy.slug}
                      </span>
                    ))
                  )}
                </div>
                {this.state.status === "active" ? (
                  <div className="col-sm-3 col-md-3">
                    {this.state.editSubnetId !== proxy.sid ? (
                      <span
                        className="lnr lnr-pencil"
                        title="Remove"
                        onClick={() => this.updateProxies(proxy)}
                      ></span>
                    ) : (
                      ""
                    )}
                    <span
                      className="lnr lnr-trash"
                      title="Remove"
                      onClick={() => this.removeProxy(proxy)}
                    ></span>
                  </div>
                ) : (
                  ""
                )}
              </div>
            ))}
          </React.Fragment>
        </form>
      </Col>
    );
  }
}

export default reduxForm({
  form: "update_proxies_form", // a unique identifier for this form
})(HorizontalForm);
